'use client';
import React from 'react';
import type { IMessage } from '@ui/components/organisms/message/message.typings';
import { TextWithLinks } from '@ui/components/moleculas/message-link';
import { twMerge } from 'tailwind-merge';

interface IProps {
  message: IMessage;
  className?: string;
  truncate?: boolean;
  amountOfWords?: number;
  isOwnPage?: boolean;
}

export const MessageItemDescription = React.memo(
  ({ message, className, truncate, amountOfWords, isOwnPage }: IProps) => {
    // Determine mode and startsTruncated based on props
    let mode: 'truncated' | 'full' | 'expandable' | undefined = undefined;
    let startsTruncated: boolean = false;

    if (isOwnPage) {
      mode = 'full'; // Single post view - show full content
    } else if (truncate) {
      mode = 'truncated'; // Always truncated, no expand
    } else {
      // Default behavior - start truncated for expandable content
      startsTruncated = true;
    }

    return (
      <div className={twMerge('max-w-[300px] rounded bg-white p-3', className)}>
        <div
          className="font-nunito text-sm"
          style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
          <TextWithLinks
            text={message.description}
            mode={mode}
            startsTruncated={startsTruncated}
            amountOfWords={amountOfWords}
            renderEmbedsInTruncatedMode={
              mode === 'truncated' && message.files?.images?.length === 0
            }
          />
        </div>
      </div>
    );
  },
);

MessageItemDescription.displayName = 'MessageItemDescription';
